
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_SURVEY_PATH } from '../constants';
import { AD_BASE_CONTACT_SURVEY_PATH } from '../constants';

export default {
  fetchAll(params) {
    return authedAxios.get(AD_BASE_SURVEY_PATH, { params: params });
  },

  fetchById(id) {
    return authedAxios.get(AD_BASE_SURVEY_PATH + id, {});
  },

  fetchByIdForReport(id) {
    return authedAxios.get(AD_BASE_SURVEY_PATH + id, {
      params: { include_retired: true },
    });
  },

  updateSurvey(id, payload) {
    return authedAxios.put(AD_BASE_SURVEY_PATH + id, payload);
  },

  createSurvey(payload) {
    return authedAxios.post(AD_BASE_SURVEY_PATH, payload);
  },

  duplicate(id) {
    return authedAxios.post(AD_BASE_SURVEY_PATH + id + '/duplicate');
  },

  assignSurvey(surveyId, payload) {
    return authedAxios.post(AD_BASE_SURVEY_PATH + surveyId + '/assign', payload);
  },

  // Specific contact surveys
  fetchContactSurveys(afterId, limit, filters, sort) {
    const params = {
      limit: limit ? limit : 100,
      filter: filters,
      sort: sort,
    };
    if (afterId) {
      params.after_id = afterId;
    }

    return authedAxios.get(AD_BASE_CONTACT_SURVEY_PATH, { params: params });
  },

  runReport(id, params = {}) {
    return authedAxios.get(AD_BASE_SURVEY_PATH + id + '/report/', { params });
  },

  runRollupReport(params = {}) {
    return authedAxios.get(AD_BASE_SURVEY_PATH + 'rollup-report/', {
      params,
    });
  },

  runRatingTrendsReport(params = {}) {
    return authedAxios.get(AD_BASE_SURVEY_PATH + 'rating-trends/', {
      params,
    });
  },

  fetchContactSurveyResponse(id) {
    return authedAxios.get(AD_BASE_CONTACT_SURVEY_PATH + id + '/responses');
  },

  cancelContactSurvey(id) {
    return authedAxios.delete(AD_BASE_CONTACT_SURVEY_PATH + id);
  },
};
